import React, { FC } from 'react';

interface IRadio {
  name?: string;
  checked?: boolean;
  onChange?: any;
}

const RadioInput: FC<IRadio> = ({ name, checked, onChange }) => (
  <input
    type="radio"
    name={name}
    value={name}
    checked={checked}
    onChange={onChange}
    data-testid="radio-input-quotes"
  />
);

export default RadioInput;
